var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Editor from '@showroomjs/bundles/react-simple-code-editor';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Div } from './base';
import { CodeHighlight } from './code-highlight';
import { LanguageTag } from './language-tag';
export const CodeEditor = (_a) => {
    var { code: providedCode, theme, language, wrapperClass } = _a, props = __rest(_a, ["code", "theme", "language", "wrapperClass"]);
    const [state, setState] = useState({
        code: providedCode,
        prevCodeProp: providedCode,
    });
    useEffect(() => {
        if (providedCode !== state.prevCodeProp) {
            setState({ code: providedCode, prevCodeProp: providedCode });
        }
    }, [providedCode]);
    const updateContent = (code) => {
        setState({ code });
        if (code !== providedCode && props.onChange) {
            props.onChange(code);
        }
    };
    const highlightCode = (code) => (React.createElement(CodeHighlight, { code: code, theme: theme, language: language }));
    // eslint-disable-next-line no-unused-vars
    const { style, onChange } = props, rest = __rest(props, ["style", "onChange"]);
    const baseTheme = theme && typeof theme.plain === 'object' ? theme.plain : {};
    return (React.createElement(Div, { css: {
            position: 'relative',
            lineHeight: 1.5,
        }, className: wrapperClass },
        React.createElement(Editor, Object.assign({ value: state.code, padding: 10, highlight: highlightCode, onValueChange: updateContent, style: Object.assign(Object.assign({ whiteSpace: 'pre', fontFamily: 'monospace', fontSize: '14px' }, baseTheme), style) }, rest)),
        language && React.createElement(LanguageTag, { language: language })));
};
//# sourceMappingURL=code-editor.js.map